import Scriba from 'react-scriba';

export class DataActualite {

    static _chargementListeDesActualites = (filtres, sortedColumn, isSortedDescending) => {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesACTUALITES";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementActualite = (actualite, images) => {
        const objet = { actualite, images };
        const url = "api/MajDonnees/EnregistrementActualite";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionActualite = (idActualite) => {
        const objet = { idActualite };
        const url = "api/MajDonnees/SuppressionActualite";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionActualites = (actualites) => {
        const objet = { actualites };
        const url = "api/MajDonnees/SuppressionActualites";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementEtPublicationActualite = (actualite, images) => {
        const objet = { actualite, images };
        const url = "api/MajDonnees/EnregistrementEtPublicationActualite";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onPublicationActualite = (idActualite) => {
        const objet = { idActualite };
        const url = "api/MajDonnees/PublicationActualite";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onPublicationActualites = (actualites) => {
        const objet = { actualites };
        const url = "api/MajDonnees/PublicationActualites";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheActualite(idActualite) {
        const objet = { idActualite };
        const url = "api/Get/ChargementActualite";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionImage = (idActualite, key) => {
        const objet = { idActualite, key };
        const url = "api/MajDonnees/SuppressionImage";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }
};
